import { request } from "./request";
import { ASSESSMENT_SUBTITLE } from "@/utils/assessmentForm";


export function getAssessmentByProjectId(data) {
  return request("/assessment/getByProjectId", {
    method: "POST",
    body: {
      projectId: String(data.projectId),
    },
  });
}

export function saveAssessment(data) {
  return request("/assessment/save", {
    method: "POST",
    body: {
      projectId: String(data.projectId),
      title: data.title || "",
      subtitle: ASSESSMENT_SUBTITLE,
      notes: data.notes || "",
      enabled: data.enabled === true,
      questions: Array.isArray(data.questions) ? data.questions : [],
    },
  });
}


/**
 * 单独切换评估表启用/禁用（给小程序识别是否需要填写）
 * POST /assessment/setEnabled
 *
 * 请求: { projectId: string, enabled: boolean }
 *   enabled=true  → 启用（小程序需填写）
 *   enabled=false → 禁用（小程序无需填写）
 *
 * 成功响应 data 建议: { projectId, enabled }
 */
export function setAssessmentEnabled(data) {
  return request("/assessment/setEnabled", {
    method: "POST",
    body: {
      projectId: String(data.projectId),
      enabled: data.enabled === true,
    },
  });
}

